"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _AdornedBox = _interopRequireDefault(require("./AdornedBox"));

var _UnadornedBox = _interopRequireDefault(require("./UnadornedBox"));

var _InputError = _interopRequireDefault(require("./InputError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputBox = function InputBox(props) {
  return _react.default.createElement(_react.default.Fragment, null, props.prefix || props.suffix ? _react.default.createElement(_AdornedBox.default, props) : _react.default.createElement(_UnadornedBox.default, props), typeof props.error === 'string' && _react.default.createElement(_InputError.default, {
    size: props.size
  }, props.error));
};

var iconShape = {
  icon: _propTypes.func,
  onClick: _propTypes.func.isRequired,
  color: _propTypes.string
};
InputBox.propTypes = {
  width: _propTypes.string,
  size: (0, _propTypes.oneOf)(['small', 'regular']),
  error: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),
  fullWidth: _propTypes.bool,
  responsive: _propTypes.bool,
  mask: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.func, _propTypes.bool, (0, _propTypes.shape)({
    mask: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.func]),
    pipe: _propTypes.func
  })]),
  prefix: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)(iconShape)]),
  suffix: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)(iconShape)])
};
InputBox.defaultProps = {
  width: undefined,
  size: 'regular',
  error: false,
  fullWidth: false,
  responsive: true,
  mask: undefined,
  prefix: undefined,
  suffix: undefined
};
var _default = InputBox;
exports.default = _default;